// Dependencies
import React from 'react'
import { useState, useEffect } from 'react';

// Helper functions
import { fetchPendingUsers } from '../../../global_components/helper_functions/fetchPendingUsers';
import { fetchAdminUsers } from '../../../global_components/helper_functions/fetchAdminUsers';
import { fetchActiveUsers } from '../../../global_components/helper_functions/fetchActiveUsers';
import { fetchSuspendedUsers } from '../../../global_components/helper_functions/fetchSuspendedUsers';
import { approveUser } from '../../../global_components/helper_functions/approveUser';
import { deleteUser } from '../../../global_components/helper_functions/deleteUser'
import { removeAdmin } from '../../../global_components/helper_functions/removeAdmin';
import { suspendUser } from '../../../global_components/helper_functions/suspendUser';
import { makeUserAdmin } from '../../../global_components/helper_functions/makeUserAdmin';

const UsersContent = () => {

  const [statusMessage, setStatusMessage] = useState("")
  const [approveUserStatusMessage, setApproveUserStatusMessage] = useState("")
  const [deleteUserStatusMessage, setDeleteUserStatusMessage] = useState("")
  const [removeAdminStatusMessage, setRemoveAdminStatusMessage] = useState("")
  const [suspendUserStatusMessage, setSuspendUserStatusMessage] = useState("")
  const [makeUserAdminStatusMessage, setMakeUserAdminStatusMessage] = useState("")
  const [pendingApprovalUsers, setPendingApprovalUsers] = useState([])
  const [adminUsers, setAdminUsers] = useState([])
  const [activeUsers, setActiveUsers] = useState([])
  const [suspendedUsers, setSuspendedUsers] = useState([])
  const [displayStatusModal, setDisplayStatusModal] = useState(false)

  useEffect(() => {
    fetchPendingUsers(setPendingApprovalUsers, setStatusMessage);
  }, []);

  useEffect(() => {
    fetchAdminUsers(setAdminUsers, setStatusMessage);
  }, []);

  useEffect(() => {
    fetchActiveUsers(setActiveUsers, setStatusMessage);
  }, []);

  useEffect(() => {
    fetchSuspendedUsers(setSuspendedUsers, setStatusMessage);
  }, []);

  const handleApproveUserClick = (userID) => {
    approveUser(userID, setApproveUserStatusMessage).then(() => {
      setDisplayStatusModal(true);
      fetchPendingUsers((newPendingUsers) => {
        setPendingApprovalUsers([...newPendingUsers]);
      }, setStatusMessage);
      fetchSuspendedUsers((newSuspendedUsers) => {
        setSuspendedUsers([...newSuspendedUsers]);
      }, setStatusMessage);
      fetchActiveUsers((newActiveUsers) => {
        setActiveUsers([...newActiveUsers]);
      }, setStatusMessage);
    });
  }

  const handleDeleteUserClick = (userID) => {
    deleteUser(userID, setDeleteUserStatusMessage).then(() => {
      setDisplayStatusModal(true);
      fetchPendingUsers((newPendingUsers) => {
        setPendingApprovalUsers([...newPendingUsers]);
      }, setStatusMessage);
      fetchActiveUsers((newActiveUsers) => {
        setActiveUsers([...newActiveUsers]);
      }, setStatusMessage);
      fetchSuspendedUsers((newSuspendedUsers) => {
        setSuspendedUsers([...newSuspendedUsers]);
      }, setStatusMessage);
    });
  }

  const handleRemoveAdminClick = (userID) => {
    removeAdmin(userID, setRemoveAdminStatusMessage).then(() => {
      setDisplayStatusModal(true);
      fetchAdminUsers((newAdminUsers) => {
        setAdminUsers([...newAdminUsers]);
      }, setStatusMessage);
    });
  }

  const handlesuspendUserClick = (userID) => {
    suspendUser(userID, setSuspendUserStatusMessage).then(() => {
      setDisplayStatusModal(true);
      fetchActiveUsers((newActiveUsers) => {
        setActiveUsers([...newActiveUsers]);
      }, setStatusMessage);
      fetchSuspendedUsers((newSuspendedUsers) => {
        setSuspendedUsers([...newSuspendedUsers]);
      }, setStatusMessage);
    });
  }

  const handleMakeUserAdminClick = (userID) => {
    makeUserAdmin(userID, setMakeUserAdminStatusMessage).then(() => {
      setDisplayStatusModal(true);
      fetchAdminUsers((newAdminUsers) => {
        setAdminUsers([...newAdminUsers]);
      }, setStatusMessage);
    });
  }

  return (
    <div className='flex flex-col items-center justify-start gap-10 w-full'>
        <div className='flex flex-col items-start justify-center p-5 sm:p-10 rounded-sm shadow-sm border border-[#DCDCDC] border-b-[#06BD60] border-b-2 w-full bg-white' id='pendingApprovalContainer'>
          <div className='flex flex-col items-start mb-5 sm:mb-10 w-full'>
            <h2 className='text-xl sm:text-2xl font-semibold mb-2'>Pending approval</h2>
            <h4 className='text-sm sm:text-base font-normal'>Users waiting to join the platform</h4>
          </div>
          <div className='overflow-x-auto w-full' id='pendingApprovalTable'>
            <table className='min-w-full mt-5'>
              <thead>
                <tr>
                  <th className='py-2 px-2 sm:px-4 text-left text-sm sm:text-lg font-medium'>Name</th>
                  <th className='py-2 px-2 sm:px-4 text-left text-sm sm:text-lg font-medium'>Email Address</th>
                  <th className='py-2 px-2 sm:px-4 text-left text-sm sm:text-lg font-medium'>Position</th>
                  <th className='py-2 px-2 sm:px-4 text-center text-sm sm:text-lg font-medium'>Accept / Remove</th>
                </tr>
              </thead>
              <tbody>
                {pendingApprovalUsers.map((person) => (
                  <tr key={person.user_id}>
                    <td className='py-2 px-2 sm:px-4 text-sm sm:text-base'>{person.full_name}</td>
                    <td className='py-2 px-2 sm:px-4 text-sm sm:text-base'>{person.email}</td>
                    <td className='py-2 px-2 sm:px-4 text-sm sm:text-base'>{person.position}</td>
                    <td className='py-2 px-2 sm:px-4 text-center'>
                      <button className='cursor-pointer mr-4 sm:mr-6' onClick={() => handleApproveUserClick(person.user_id)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#06BD60" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-check-circle">
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
                        </svg>
                      </button>
                      <button className='cursor-pointer' onClick={() => handleDeleteUserClick(person.user_id)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f56565" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x-square">
                          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><line x1="9" y1="9" x2="15" y2="15"/><line x1="15" y1="9" x2="9" y2="15"/>
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className='flex flex-col items-start justify-center p-5 sm:p-10 rounded-sm shadow-sm border border-[#DCDCDC] border-b-[#06BD60] border-b-2 w-full bg-white' id='adminUsersContainer'>
          <div className='flex flex-col items-start mb-5 sm:mb-10 w-full'>
            <h2 className='text-xl sm:text-2xl font-semibold mb-2'>Admin users</h2>
            <h4 className='text-sm sm:text-base font-normal mb-5'>Admin level access users</h4>
          </div>
          <div className='overflow-x-auto w-full' id='adminUsersTable'>
            <table className='min-w-full bg-white mt-5'>
              <thead>
                <tr>
                  <th className='py-2 px-2 sm:px-4 text-left text-sm sm:text-lg font-medium'>Name</th>
                  <th className='py-2 px-2 sm:px-4 text-left text-sm sm:text-lg font-medium'>Email Address</th>
                  <th className='py-2 px-2 sm:px-4 text-left text-sm sm:text-lg font-medium'>Position</th>
                  <th className='py-2 px-2 sm:px-4 text-center text-sm sm:text-lg font-medium'>Remove admin</th>
                </tr>
              </thead>
              <tbody>
                {adminUsers.map((person) => (
                  <tr key={person.user_id}>
                    <td className='py-2 px-2 sm:px-4 text-sm sm:text-base'>{person.full_name}</td>
                    <td className='py-2 px-2 sm:px-4 text-sm sm:text-base'>{person.email}</td>
                    <td className='py-2 px-2 sm:px-4 text-sm sm:text-base'>{person.position}</td>
                    <td className='py-2 px-2 sm:px-4 text-center'>
                      <button className='cursor-pointer' onClick={() => handleRemoveAdminClick(person.user_id)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f56565" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x-square">
                          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                          <line x1="9" y1="9" x2="15" y2="15"/>
                          <line x1="15" y1="9" x2="9" y2="15"/>
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className='flex flex-col items-start justify-center p-5 sm:p-10 rounded-sm shadow-sm border border-[#DCDCDC] border-b-[#06BD60] border-b-2 w-full bg-white' id='activeUsersContainer'>
          <div className='flex flex-col items-start mb-5 sm:mb-10 w-full'>
            <h2 className='text-xl sm:text-2xl font-semibold mb-2'>Active users</h2>
            <h4 className='text-sm sm:text-base font-normal'>Users active on the platform</h4>
          </div>
          <div className='overflow-x-auto w-full' id='activeUsersTable'>
            <table className='min-w-full bg-white mt-5'>
              <thead>
                <tr>
                  <th className='py-2 px-2 sm:px-4 text-left text-sm sm:text-lg font-medium'>Name</th>
                  <th className='py-2 px-2 sm:px-4 text-left text-sm sm:text-lg font-medium'>Email Address</th>
                  <th className='py-2 px-2 sm:px-4 text-left text-sm sm:text-lg font-medium'>Position</th>
                  <th className='py-2 px-2 sm:px-4 text-center text-sm sm:text-lg font-medium'>Suspend / Remove</th>
                  <th className='py-2 px-2 sm:px-4 text-center text-sm sm:text-lg font-medium'></th>
                </tr>
              </thead>
              <tbody>
                {activeUsers.map((person) => (
                  <tr key={person.user_id}>
                    <td className='py-2 px-2 sm:px-4 text-sm sm:text-base'>{person.full_name}</td>
                    <td className='py-2 px-2 sm:px-4 text-sm sm:text-base'>{person.email}</td>
                    <td className='py-2 px-2 sm:px-4 text-sm sm:text-base'>{person.position}</td>
                    <td className='py-2 px-2 sm:px-4 text-center'>
                      <button className='cursor-pointer mr-6' onClick={() => handlesuspendUserClick(person.user_id)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-stop-circle stroke-orange-400">
                          <circle cx="12" cy="12" r="10"/>
                          <rect x="9" y="9" width="6" height="6"/>
                        </svg>
                      </button>
                      <button className='cursor-pointer' onClick={() => handleDeleteUserClick(person.user_id)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f56565" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x-square">
                          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                          <line x1="9" y1="9" x2="15" y2="15"/>
                          <line x1="15" y1="9" x2="9" y2="15"/>
                        </svg>
                      </button>
                    </td>
                    <td className='py-2 px-2 sm:px-4 text-center'>
                      <button className='cursor-pointer text-sm sm:text-base text-[#06BD60] font-normal' onClick={() => handleMakeUserAdminClick(person.user_id)}>
                        Make admin
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className='flex flex-col items-start justify-center p-5 sm:p-10 rounded-sm shadow-sm border border-[#DCDCDC] border-b-[#06BD60] border-b-2 w-full mb-10 bg-white' id='suspendedUsersContainer'>
          <div className='flex flex-col items-start mb-5 sm:mb-10 w-full'>
            <h2 className='text-xl sm:text-2xl font-semibold mb-2'>Suspended Users</h2>
            <h4 className='text-sm sm:text-base font-normal'>Users who have been suspended</h4>
          </div>
          <div className='overflow-x-auto w-full' id='pendingApprovalTable'>
            <table className='min-w-full bg-white mt-5'>
              <thead>
                <tr>
                  <th className='py-2 px-2 sm:px-4 text-left text-sm sm:text-lg font-medium'>Name</th>
                  <th className='py-2 px-2 sm:px-4 text-left text-sm sm:text-lg font-medium'>Email Address</th>
                  <th className='py-2 px-2 sm:px-4 text-left text-sm sm:text-lg font-medium'>Position</th>
                  <th className='py-2 px-2 sm:px-4 text-center text-sm sm:text-lg font-medium'>Accept / Remove</th>
                </tr>
              </thead>
              <tbody>
                {suspendedUsers.map((person) => (
                  <tr key={person.user_id}>
                    <td className='py-2 px-2 sm:px-4 text-sm sm:text-base'>{person.full_name}</td>
                    <td className='py-2 px-2 sm:px-4 text-sm sm:text-base'>{person.email}</td>
                    <td className='py-2 px-2 sm:px-4 text-sm sm:text-base'>{person.position}</td>
                    <td className='py-2 px-2 sm:px-4 text-center'>
                      <button className='cursor-pointer mr-6' onClick={() => handleApproveUserClick(person.user_id)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#06BD60" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-check-circle">
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                          <polyline points="22 4 12 14.01 9 11.01"/>
                        </svg>
                      </button>
                      <button className='cursor-pointer' onClick={() => handleDeleteUserClick(person.user_id)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f56565" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x-square">
                          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                          <line x1="9" y1="9" x2="15" y2="15"/>
                          <line x1="15" y1="9" x2="9" y2="15"/>
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className={`${displayStatusModal ? 'flex' : 'hidden'} items-center justify-center w-screen h-screen bg-black/30 fixed inset-0 p-5 sm:p-40`} id='statusDisplayModal'>
          <div className='flex flex-col items-center bg-white p-5 sm:p-15 rounded-sm max-w-xs sm:max-w-lg w-full'>
            <p className='text-sm sm:text-base font-regular text-center mb-2'>{approveUserStatusMessage}</p>
            <p className='text-sm sm:text-base font-regular text-center mb-2'>{deleteUserStatusMessage}</p>
            <p className='text-sm sm:text-base font-regular text-center mb-2'>{removeAdminStatusMessage}</p>
            <p className='text-sm sm:text-base font-regular text-center mb-2'>{suspendUserStatusMessage}</p>
            <p className='text-sm sm:text-base font-regular text-center mb-5'>{makeUserAdminStatusMessage}</p>
            <button className='py-2 px-5 bg-red-500 text-white rounded-sm font-semibold cursor-pointer mt-5 sm:mt-7' onClick={() => setDisplayStatusModal(false)}>Dismiss</button>
          </div>
        </div>
    </div>
  )
}

export default UsersContent